import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לשים לב לנטישה",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה להבין הכול.",
      "אני רק שם/ה לב לתחושת הנטישה.",
      "זה מספיק לרגע."
    ],
      [
      "היום אני לא מנסה להבין הכול.",
      "אני רק שם/ה לב לתחושת הנטישה.",
      "זה מספיק לרגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי תחושת הנטישה הכי מורגשת לי?",
      "מה קורה סביבי אז?",
      "איך זה מרגיש בגוף שלי?"
    ],
      [
      "מתי תחושת הנטישה הכי מורגשת לי?",
      "מה קורה סביבי אז?",
      "איך זה מרגיש בגוף שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לשים לב זה כבר התחלה של חיבור."
    ],
      [
      "לשים לב זה כבר התחלה של חיבור."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת עם המילים \"אני כאן\".",
      "נשימה אחת עם המילים \"אני כאן\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מה חסר לי",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב למה שהיה חסר אז.",
      "בלי האשמה.",
      "רק לראות."
    ],
      [
      "היום אני שם/ה לב למה שהיה חסר אז.",
      "בלי האשמה.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הייתי בוחר/ת/ה ולא קיבלתי?",
      "מה אני עדיין מבקש/ת היום?",
      "מה קשה לי לבקש מאחרים?"
    ],
      [
      "מה הייתי בוחר/ת/ה ולא קיבלתי?",
      "מה אני עדיין מבקש/ת היום?",
      "מה קשה לי לבקש מאחרים?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "חסר קטן מסביר הרבה."
    ],
      [
      "חסר קטן מסביר הרבה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת על מה שחסר.",
      "לכתוב מילה אחת על מה שחסר."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "הדרך שבה זה נשאר בי",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב למה שנשאר בי מאז.",
      "בלי שיפוט.",
      "רק אמת."
    ],
      [
      "היום אני שם/ה לב למה שנשאר בי מאז.",
      "בלי שיפוט.",
      "רק אמת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך זה משפיע עליי היום?",
      "איפה אני מרגיש/ה את זה בקשרים?",
      "מה אני מנסה להגן עליו?"
    ],
      [
      "איך זה משפיע עליי היום?",
      "איפה אני מרגיש/ה את זה בקשרים?",
      "מה אני מנסה להגן עליו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מה שנשאר בי מבקש עדינות."
    ],
      [
      "מה שנשאר בי מבקש עדינות."
    ]
    ),
    action: localizedGenderNode(
      "לומר לעצמי \"אני רואה אותך\".",
      "לומר לעצמי \"אני רואה אותך\"."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "החלק שמרגיש לבד",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לחלק בי שמרגיש לבד.",
      "לא לתקן.",
      "רק להיות איתו."
    ],
      [
      "היום אני שם/ה לב לחלק בי שמרגיש לבד.",
      "לא לתקן.",
      "רק להיות איתו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה הוא יושב בי?",
      "מה הוא בוחר/ת ממני עכשיו?",
      "איך זה מרגיש להיות איתו רגע?"
    ],
      [
      "איפה הוא יושב בי?",
      "מה הוא בוחר/ת ממני עכשיו?",
      "איך זה מרגיש להיות איתו רגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להיות איתו לרגע הוא כבר שינוי קטן."
    ],
      [
      "להיות איתו לרגע הוא כבר שינוי קטן."
    ]
    ),
    action: localizedGenderNode(
      "לשים יד על הלב ולנשום.",
      "לשים יד על הלב ולנשום."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הפחד להישען",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת את הפחד להישען.",
      "לא להילחם.",
      "רק להכיר."
    ],
      [
      "היום אני בודק/ת את הפחד להישען.",
      "לא להילחם.",
      "רק להכיר."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "ממה אני מפחד/ת כשאני נשען/ת?",
      "מה אני חושב/ת שיקרה?",
      "איך הפחד הזה שומר עליי?"
    ],
      [
      "ממה אני מפחד/ת כשאני נשען/ת?",
      "מה אני חושב/ת שיקרה?",
      "איך הפחד הזה שומר עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הפחד להישען הוא ניסיון לשמור."
    ],
      [
      "הפחד להישען הוא ניסיון לשמור."
    ]
    ),
    action: localizedGenderNode(
      "לומר לעצמי \"אני רואה אותך\".",
      "לומר לעצמי \"אני רואה אותך\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "בקשה קטנה לביטחון",
    opening: localizedGenderNode(
      [
      "היום אני מנסח/ת בקשה קטנה לביטחון.",
      "לא גדולה.",
      "קטנה."
    ],
      [
      "היום אני מנסח/ת בקשה קטנה לביטחון.",
      "לא גדולה.",
      "קטנה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה נותן לי תחושת ביטחון קטנה?",
      "איך אפשר לבקש זאת בעדינות?",
      "מה צעד קטן בכיוון?"
    ],
      [
      "מה נותן לי תחושת ביטחון קטנה?",
      "איך אפשר לבקש זאת בעדינות?",
      "מה צעד קטן בכיוון?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת יכולה להרגיע את הלב."
    ],
      [
      "בקשה אחת יכולה להרגיע את הלב."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט אחד.",
      "לכתוב את הבקשה במשפט אחד."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "רגע קטן של קרבה",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת רגע קטן של קרבה בטוחה.",
      "לא הרבה.",
      "רק מעט."
    ],
      [
      "היום אני מחפש/ת רגע קטן של קרבה בטוחה.",
      "לא הרבה.",
      "רק מעט."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הייתה לי קרבה בטוחה לאחרונה?",
      "מה אפשר לה להתרחש?",
      "מה יכול להזמין עוד רגע כזה?"
    ],
      [
      "מתי הייתה לי קרבה בטוחה לאחרונה?",
      "מה אפשר לה להתרחש?",
      "מה יכול להזמין עוד רגע כזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "רגע קטן משנה כיוון."
    ],
      [
      "רגע קטן משנה כיוון."
    ]
    ),
    action: localizedGenderNode(
      "לזכור רגע כזה.",
      "לזכור רגע כזה."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "גבול שמגן עליי",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת גבול קטן שמגן עליי.",
      "לא כדי להתרחק.",
      "רק לשמור."
    ],
      [
      "היום אני בודק/ת גבול קטן שמגן עליי.",
      "לא כדי להתרחק.",
      "רק לשמור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הכתפיים."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הכתפיים."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני נותן/ת יותר מדי?",
      "איזה גבול קטן יקל עליי?",
      "איך אני יכול/ה לומר אותו לעצמי?"
    ],
      [
      "איפה אני נותן/ת יותר מדי?",
      "איזה גבול קטן יקל עליי?",
      "איך אני יכול/ה לומר אותו לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גבול קטן שומר על הלב."
    ],
      [
      "גבול קטן שומר על הלב."
    ]
    ),
    action: localizedGenderNode(
      "משפט גבול אחד לעצמי.",
      "משפט גבול אחד לעצמי."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "להישאר עם עצמי",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להישאר עם עצמי כשעולה הנטישה.",
      "לא לברוח.",
      "רק להיות."
    ],
      [
      "היום אני מתרגל/ת להישאר עם עצמי כשעולה הנטישה.",
      "לא לברוח.",
      "רק להיות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה עוזר לי להישאר איתי?",
      "מה מוציא אותי מעצמי?",
      "מה יכול לעזור לי לחזור?"
    ],
      [
      "מה עוזר לי להישאר איתי?",
      "מה מוציא אותי מעצמי?",
      "מה יכול לעזור לי לחזור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להישאר איתי הוא עוגן קטן."
    ],
      [
      "להישאר איתי הוא עוגן קטן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת בכל פעם שעולה התחושה.",
      "נשימה אחת בכל פעם שעולה התחושה."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "בקשה אחת ברורה",
    opening: localizedGenderNode(
      [
      "היום אני מנסח/ת בקשה אחת ברורה לעצמי.",
      "לא גדולה.",
      "ברורה."
    ],
      [
      "היום אני מנסח/ת בקשה אחת ברורה לעצמי.",
      "לא גדולה.",
      "ברורה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני בוחר/ת/ה עכשיו כדי להרגיש בטוח/ה?",
      "איך אפשר לבקש זאת בעדינות?",
      "מה צעד קטן בכיוון?"
    ],
      [
      "מה אני בוחר/ת/ה עכשיו כדי להרגיש בטוח/ה?",
      "איך אפשר לבקש זאת בעדינות?",
      "מה צעד קטן בכיוון?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת ברורה יכולה להרגיע."
    ],
      [
      "בקשה אחת ברורה יכולה להרגיע."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט אחד.",
      "לכתוב את הבקשה במשפט אחד."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "ערך אחד שמחזיק אותי",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת ערך אחד שמחזיק אותי.",
      "קטן.",
      "אבל אמיתי."
    ],
      [
      "היום אני מחפש/ת ערך אחד שמחזיק אותי.",
      "קטן.",
      "אבל אמיתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה ערך חשוב לי בתוך קשר?",
      "איך הערך הזה נראה ביום רגיל?",
      "מה צעד קטן שיכבד אותו?"
    ],
      [
      "איזה ערך חשוב לי בתוך קשר?",
      "איך הערך הזה נראה ביום רגיל?",
      "מה צעד קטן שיכבד אותו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ערך אחד הוא חוט של יציבות."
    ],
      [
      "ערך אחד הוא חוט של יציבות."
    ]
    ),
    action: localizedGenderNode(
      "מילה אחת שמבטאת את הערך.",
      "מילה אחת שמבטאת את הערך."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "להקשיב לצורך שלי",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לצורך שלי.",
      "לא לדחות.",
      "רק לשמוע."
    ],
      [
      "היום אני מקשיב/ה לצורך שלי.",
      "לא לדחות.",
      "רק לשמוע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הבטן."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הבטן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הצורך הכי חי בי עכשיו?",
      "איך הוא נשמע במילים פשוטות?",
      "מה יכול לתת לו טיפת מקום?"
    ],
      [
      "מה הצורך הכי חי בי עכשיו?",
      "איך הוא נשמע במילים פשוטות?",
      "מה יכול לתת לו טיפת מקום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לשמוע את הצורך הוא כבר שינוי."
    ],
      [
      "לשמוע את הצורך הוא כבר שינוי."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הצורך במילה אחת.",
      "לכתוב את הצורך במילה אחת."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "צעד קטן של ביטחון",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן של ביטחון.",
      "בלי דרמה.",
      "צעד קטן."
    ],
      [
      "היום אני בוחר/ת צעד קטן של ביטחון.",
      "בלי דרמה.",
      "צעד קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ],
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "צעד קטן מספיק כדי להתקרב."
    ],
      [
      "צעד קטן מספיק כדי להתקרב."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד אחד קטן ולזכור אותו.",
      "לבחור צעד אחד קטן ולזכור אותו."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת משפט שמחזיר אותי לביטחון.",
      "כשאני נבהל/ת.",
      "משפט קטן."
    ],
      [
      "היום אני בוחר/ת משפט שמחזיר אותי לביטחון.",
      "כשאני נבהל/ת.",
      "משפט קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על הנטישה הזו?",
      "מה הסימן הראשון שהיא חוזרת?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ],
      [
      "מה למדתי על הנטישה הזו?",
      "מה הסימן הראשון שהיא חוזרת?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה להרגיש נטוש/ה ולהישאר עם עצמי."
    ],
      [
      "אני יכול/ה להרגיש נטוש/ה ולהישאר עם עצמי."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט החדש פעם אחת.",
      "לומר את המשפט החדש פעם אחת."
    ),
  },
].map(buildNormalizedDay);

export const feelingOfAbandonmentParentsAreEmotionallyPhysicallyUnavailableBlueprintHe = buildNormalizedPilotBlueprint({
  id: "feeling_of_abandonment_parents_are_emotionally_physically_unavailable_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "feeling_of_abandonment_parents_are_emotionally_physically_unavailable",
  category: "childhood_parents_past_wounds",
  journeyName: {
    he: "תחושת נטישה (הורים לא זמינים רגשית / פיזית)",
    en: "Feeling of abandonment (parents emotionally/physically unavailable)",
    es: "Sensación de abandono (padres no disponibles emocional o físicamente)",
  },
  days,
});

export default feelingOfAbandonmentParentsAreEmotionallyPhysicallyUnavailableBlueprintHe;
